import React, { useRef } from 'react'
import { useDragLayer, DragLayerMonitor } from 'react-dnd'

import BasicCard from 'components/card/BasicCard'
import CardLoader from 'components/card/CardLoader'

import styles from './cardDragLayer.module.scss'

type Props = {
  playtester?: boolean
  cardClass?: string
  centerDrag?: boolean
}

const CardDragLayer = ({ playtester, cardClass, centerDrag }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const cardRef = useRef<HTMLDivElement>(null)

  const handleOffsetChange = (monitor: DragLayerMonitor) => {
    if (!ref.current) return

    const offset = monitor.getClientOffset()
    const currentHeight = cardRef?.current?.clientHeight || 0
    const currentWidth = cardRef?.current?.clientWidth || 0

    if (!offset) return (ref.current.style.transform = '')

    const transform = centerDrag
      ? `translate(${offset.x - currentWidth / 2}px, ${offset.y - currentHeight / 2}px)`
      : `translate(${offset.x}px, ${offset.y}px)`

    ref.current.style.transform = transform
  }

  const { isDragging, item } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    isDragging: monitor.isDragging(),
    onOffsetChange: handleOffsetChange(monitor),
  }))

  // The shape of the objects is slightly different between playtester & deck
  // I'd like to change it, but I looked into it and there was something more massive than I wanted to change to make it happen (currently)
  const card = playtester ? item : item?.card || null
  const multiDrags = Object.keys(item?.multiSelectedIds || {}).length

  if (!isDragging) return null
  if (!card && !multiDrags) return null

  if (multiDrags)
    return (
      <div className={styles.layerContainer} ref={ref}>
        <div ref={cardRef} className={styles.multiCardContainer}>
          <CardLoader loading />
          <span className={styles.counter}>{multiDrags}</span>
        </div>
      </div>
    )

  return (
    <div className={styles.layerContainer} ref={ref}>
      <BasicCard card={card} className={`${cardClass} ${card.tapped && styles.tapped}`} ref={cardRef} />
    </div>
  )
}

export default CardDragLayer
